<template>
  <div 
    class="mt-5">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <v-dialog v-model="dialog.freeze"
          @keydown.esc="dialog.freeze = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Freeze Kolom

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0">
              <v-form>
                <v-row>
                  <v-col>
                    <div>
                      <div 
                        class="mb-2">
                        Silahkan pilih kolom yang akan di <b class="font-italic">"Freeze"</b>
                      </div>

                      <v-list-item-group
                        multiple>
                        <v-list flat>
                          <v-list-item 
                            v-for="(item, index) in configHeaders" 
                            :key="index"
                            class="px-0"
                            @click="item.freeze = !item.freeze ? true : false">
                            <v-list-item-action 
                              class="mr-4">
                              <v-checkbox
                                :color="set_color"
                                :input-value="item.freeze">
                              </v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <div
                                :class="item.freeze ? 'font-weight-bold' : ''"
                                :style="item.freeze ? `color: ${set_color};` : ''">
                                {{ item.text }}
                              </div>
                            </v-list-item-content>
                          </v-list-item>  
                        </v-list>
                      </v-list-item-group>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                :color="set_color"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Freeze
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.hide"
          @keydown.esc="dialog.hide = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Hide Kolom

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.hide = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0">
              <v-form>
                <v-row>
                  <v-col>
                    <div>
                      <div class="mb-2">
                        Silahkan pilih kolom yang akan di <b class="font-italic">"Hide"</b>
                      </div>

                      <v-list-item-group
                        multiple>
                        <v-list flat>
                          <v-list-item 
                            v-for="(item, index) in headers" 
                            :key="index"
                            class="px-0"
                            @click="item.hide = !item.hide ? true : false">
                            <v-list-item-action 
                              class="mr-4">
                              <v-checkbox
                                :color="set_color"
                                :input-value="item.hide">
                              </v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <div
                                :class="item.hide ? 'font-weight-bold' : ''"
                                :style="item.hide ? `color: ${set_color};` : ''">
                                {{ item.text }}
                              </div>
                            </v-list-item-content>
                          </v-list-item>  
                        </v-list>
                      </v-list-item-group>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                :color="set_color"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.hide = false; dialog.fullscreen = false; addHides();">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Hide
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.filter"
          @keydown.esc="dialog.filter = false"
          :fullscreen="dialog.fullscreen"
          width="600"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                Filter Data
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.filter = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <div>
                
              </div>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn 
                @click="dialog.filter = false; fetch();"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Filter
              </v-btn>

              <v-btn 
                @click="dialog.filter = false"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.komfirmasi"
          @keydown.esc="dialog.komfirmasi = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              Konfirmasi

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.komfirmasi = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second mt-4">
              <span v-if="message.komfirmasi === 'buka'">
                Anda yakin ingin melakukan buka buku?
              </span>
              <span v-else>
                Anda yakin ingin melakukan tutup buku?
              </span>
            </v-card-text>

            <div v-if="message.error.length > 0"
              class="text-center mx-6 my-4">
              <div
                class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                Ya, Yakin
              </v-btn>

              <v-btn
                rounded
                width="120"
                @click="dialog.komfirmasi = false; dialog.fullscreen = false;"
                :disabled="process.form"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- <v-dialog v-model="dialog.detail"
          @keydown.esc="dialog.detail = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Detail Perusahaan

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.detail = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0" v-if="Object">
              <v-form>
                <v-row>
                  <v-col cols="6">
                    
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                :color="set_color"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.detail = false; dialog.fullscreen = false; ">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Tutup
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog> -->
        
        <section>
          <!-- <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                flat
                color="transparent">
                <div
                  class="d-flex align-center">
                  <div
                    class="d-flex align-center">
                    <v-avatar
                      tile
                      size="30">
                      <v-img
                        contain
                        alt="kominfoklaten"  
                        :src="require('@/assets/image/grip_menu.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>

                    <span
                      class="title black--text ml-2"
                      style="font-weight: 600;">
                      Pegawai
                    </span>
                  </div>

                  <v-spacer />

                  <div>
                    <v-btn
                      to="/user/add"
                      color="#4B4B4B"
                      elevation="0"
                      class="body-2 white--text text-capitalize d-flex align-center"
                      style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                      <v-icon size="20">mdi-plus-circle-multiple</v-icon>
                      
                      <span
                        class="ml-2">
                        Tambah
                      </span>
                    </v-btn>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row> -->
          <!-- <v-row>
            <v-col cols="12" class="py-0" style="width: fit-content;"> -->
            <div>
              <v-card
                flat
                class="mt-2"
                color="transparent">
                <div
                  class="d-flex align-center px-3">
                  <div
                    class="d-flex align-center">
                    <v-avatar
                      tile
                      size="22">
                      <v-img
                        contain
                        alt="kominfoklaten"  
                        :src="require('@/assets/image/grip_menu.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>
    
                    <span
                      class="fs-16 black--text ml-2"
                      style="font-weight: 600;">
                      Trial Balance {{ closing_month | month_year }}
                    </span>
                  </div>
    
                  <v-spacer />
    
                </div>
              </v-card>
              <div class="px-4">
                <v-tabs
                  v-model="tab"
                  dense
                  background-color="transparent"
                  slider-size="5"
                  v-on:change="fetch()"
                  :color="set_color">
                  <v-tab
                    v-for="(item, index) in tabs"
                    :key="index">
                    <span
                      class="body-2 font-weight-medium text-capitalize">
                      {{ item }}
                    </span>
                  </v-tab>
                </v-tabs>
                <v-divider style="border-color: #EBEEF2;"></v-divider>
              </div>
              
              <div class="d-flex mt-3 px-4">
                <!-- <div>
                  <v-menu
                    ref="menu2"
                    v-model="menu2"
                    :close-on-content-click="false"
                    :return-value.sync="filter.date"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                    >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="filter.date"
                        :color="set_color"
                        placeholder="Pilihan periode"
                        prepend-inner-icon="mdi-calendar"
                        hide-details
                        readonly
                        filled
                        rounded
                        clearable
                        dense
                        v-bind="attrs"
                        v-on="on"
                        style="border-radius: 10px;"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filter.date"
                      no-title
                      scrollable
                      type="month"
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="menu2 = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu2.save(filter.date)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </div> -->
                <div class="d-flex align-center" style="">
                  <!-- <v-select
                    filled
                    rounded
                    dense
                    hide-details
    
                    :color="set_color"
                    placeholder="Contoh. 2023"
    
                    :items="years"
                    :item-color="set_color"
                    class="fs-12 little-placeholder"
    
                    v-model="filter.year"
                    style="border-radius: 10px; width: 200px; max-width: 200px;">
                  </v-select> -->
                  <div class="fs-13 font-weight-bold black--text mr-3">
                    Bulan Terakhir Tutup Buku: {{ delete_month | month_year }}
                  </div>
                  
                  <!-- <div>
                    |
                  </div>
                  <div class="fs-13 font-weight-bold black--text ml-3">
                    Bulan Terakhir Buka Buku: {{ closing_month | month_year }}
                  </div> -->
                  <!-- <div class="ml-auto d-flex">
                    <div>
                      <div style="" class="text-right px-4 d-flex align-center">
                        <div class="black_one fs-12 font_weight_600">
                          Total Aktiva: 
                        </div>
                        <div class="font_weight_600 fs-15 ml-2" :class="(total_aktiva !== total_pasiva) ? 'red--text' : 'black_one'">
                          {{ total_aktiva | price }}
                        </div>
                      </div>
                    </div>
                    <div>
                      <div style="" class="text-right px-4 d-flex align-center">
                        <div class="black_one font_weight_600 fs-12">
                          Total Pasiva: 
                        </div>
                        <div class="font_weight_600 fs-15 ml-2" :class="(total_aktiva !== total_pasiva) ? 'red--text' : 'black_one'">
                          {{ total_pasiva | price }}
                        </div>
                      </div>
                    </div>
                  </div> -->
                </div>
              </div>
              <v-row
                class="pa-4 py-0 mt-1">
                <v-col 
                  cols="12"
                  class="py-0">
                  <v-card 
                    flat
                    style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                      <v-card-text
                        v-if="process.load" 
                        class="pb-0 my-4" 
                        style="height: calc(100vh - 250px); width: 100%; display: flex; align-items: center; justify-content: center;">
                        <div class="text-center">
                          <div class="mb-4 title">
                            Mohon Tunggu . . .
                          </div>
    
                          <v-progress-linear
                            :color="set_color"
                            indeterminate
                            rounded
                            height="10">
                          </v-progress-linear>
                        </div>
                      </v-card-text>
    
                      <div v-if="!process.load">
                        <v-card-text class="px-0 pt-0 pb-0">
                          <table style="width: fit-content;">
                            <tr>
                              <td class="fs-12 font_weight_600 white--text py-2 px-5" style="border-bottom: 1px solid #eee; min-width: 200px; width: 200px" :style="`background-color: ${set_color};`">
                                No. Akun
                              </td>
                              <td class="fs-12 py-2 font_weight_600 white--text" style="border-bottom: 1px solid #eee; width: 400px; max-width: 400px; min-width: 400px; padding-left: 30px;" :style="`background-color: ${set_color};`">
                                Nama Akun
                              </td>
                              <td class="fs-12 py-2 font_weight_600 white--text text-right px-0" style="border-bottom: 1px solid #eee; width: 196px; max-width: 196px; min-width: 196px" :style="`background-color: ${set_color};`">
                                Saldo Awal
                              </td>
                              <td class="fs-12 py-2 font_weight_600 white--text text-right px-0" style="border-bottom: 1px solid #eee; width: 196px; max-width: 196px; min-width: 196px" :style="`background-color: ${set_color};`">
                                Total Debit
                              </td>
                              <td class="fs-12 py-2 font_weight_600 white--text text-right px-0" style="border-bottom: 1px solid #eee; width: 196px; max-width: 196px; min-width: 196px" :style="`background-color: ${set_color};`">
                                Total Kredit
                              </td>
                              <td class="fs-12 py-2 font_weight_600 white--text text-right px-0" style="border-bottom: 1px solid #eee; width: 196px; max-width: 196px; min-width: 196px" :style="`background-color: ${set_color};`">
                                Saldo Akhir
                              </td>
                              <td class="fs-12 py-2 font_weight_600 white--text text-right px-0" style="border-bottom: 1px solid #eee; width: 100%" :style="`background-color: ${set_color};`">
                                
                              </td>
                            </tr>
                          </table>
                          <!-- <div class="d-flex align-center mt-0 px-5" style="border-bottom: 1px solid #eee; background: #080679">
                            <div style="min-width: 191px; width: 191px" class="fs-12 font_weight_600 white--text py-2">
                              No. Akun
                            </div>
                            <div style="min-width: 400px; padding-left: 30px;" class="fs-12 py-2 font_weight_600 white--text">
                              Nama Akun
                            </div>
                            <div class="fs-12 ml-auto py-2 font_weight_600 white--text pr-0 text-right" style="width: 175px; max-width: 175px; min-width: 175px;">
                              Saldo Awal
                            </div>
                            <div class="fs-12 ml-auto py-2 font_weight_600 white--text pr-0 text-right" style="width: 175px; max-width: 175px; min-width: 175px;">
                              Total Debit
                            </div>
                            <div class="fs-12 ml-auto py-2 font_weight_600 white--text pr-0 text-right" style="width: 175px; max-width: 175px; min-width: 175px;">
                              Total Kredit
                            </div>
                            <div class="ml-auto py-2 font_weight_600 white--text pr-0 text-right" style="width: 175px; max-width: 175px; min-width: 175px;">
                              Saldo Akhir
                            </div>
                          </div> -->
                          <div style="height: calc(100vh - 300px); overflow-y: auto; overflow-x: auto; width: fit-content">
                            <div class="fs-14 pb-2 pt-2 black_one font_weight_600 px-5 pr-2" style="position: sticky; top: 0; background: #fff; z-index: 1;">
                              <div class="d-flex align-center">
                                <div>
                                  Aktiva
                                </div>
                                <!-- <div class="ml-auto">
                                  {{ total_aktiva | price }}
                                </div> -->
                              </div>
                            </div>
                            <v-treeview
                              :items="list_aktiva"
                              item-key="id"
                              activatable
                              open-all

                              item-children="child"
                              item-text="test"
                              class="border_buttom_tree fs-12"
                            >
                              <template v-slot:prepend="{ item }">
                                <!-- <v-icon v-if="item.child">
                                  {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                                </v-icon>
                                <v-icon v-else>{{ 'mdi-file-document-outline' }}</v-icon> -->
                                <div class="d-flex">
                                  <div :class="item.child.length > 0 || item.is_parent === true  ? 'font_weight_600' : ''">
                                    {{ item.number }}
                                  </div>
                                </div>
        
                                <!-- <v-tooltip 
                                  top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      v-bind="attrs"
                                      v-on="on"
                                      min-width="24"
                                      min-height="24"
                                      x-small
                                      rounded
                                      @click="dialog.status = true; reset(item);"
                                      color="orange"
                                      elevation="0"
                                      class="white--text text-capitalize mx-1 px-0"
                                      style="font-weight: 600; border-radius: 6px;">
                                      <v-icon size="12">mdi-file-cancel</v-icon>
                                      
                                    </v-btn>
                                  </template>
          
                                  <span>Nonaktifkan</span>
                                </v-tooltip> -->
        

                              </template>
                              <!-- <template v-slot:label="{item}">
                                <div class="v-treeview-node__label">{{item.data.name_label}}</div>
                              </template> -->
                              <template v-slot:append="{ item }">
                                <div class="d-flex">
                                  <div style="min-width: 400px; max-width: 400px; padding-left: 30px;" :class="item.child.length > 0 || item.is_parent === true  ? 'font_weight_600 fs-11' : 'fs-11'">
                                    {{ item.name }}
                                  </div>
                                  <div class="ml-auto text-right" style="min-width: 196px; padding-left: 70px;" calss="text-capitalize" :class="item.child.length > 0 || item.is_parent === true  ? 'font_weight_600 fs-11' : 'fs-11'">
                                    {{ item.saldo_awal | price }}
                                  </div>
                                  <div class="ml-auto text-right" style="min-width: 196px; padding-left: 70px;" calss="text-capitalize" :class="item.child.length > 0 || item.is_parent === true  ? 'font_weight_600 fs-11' : 'fs-11'">
                                    {{ item.total_debit | price }}
                                  </div>
                                  <div class="ml-auto text-right" style="min-width: 196px; padding-left: 70px;" calss="text-capitalize" :class="item.child.length > 0 || item.is_parent === true  ? 'font_weight_600 fs-11' : 'fs-11'">
                                    {{ item.total_kredit | price }}
                                  </div>
                                  <div class="ml-auto text-right" style="min-width: 196px; padding-left: 70px;" calss="text-capitalize" :class="item.child.length > 0 || item.is_parent === true  ? 'font_weight_600 fs-11' : 'fs-11'">
                                    {{ item.saldo_akhir | price }}
                                  </div>
                                </div>
                              </template>
                            </v-treeview>


                          <table style="width: fit-content;">
                            <tr>
                              <td class="fs-12 font_weight_600 black--text py-1 px-5" style="border-top: 1px solid #eee; background: #f4faff; min-width: 200px; width: 200px">
                                TOTAL AKTIVA
                              </td>
                              <td class="fs-12 py-1 font_weight_600 black--text" style="border-top: 1px solid #eee; background: #f4faff; width: 400px; max-width: 400px; min-width: 400px; padding-left: 30px; text-align: left;">
                                
                              </td>
                              <td class="fs-12 py-1 font_weight_600 black--text text-right px-0" style="border-top: 1px solid #eee; background: #f4faff; width: 198px; max-width: 198px; min-width: 198px">
                                {{ total_aktiva.saldo_awal | price }}
                              </td>
                              <td class="fs-12 py-1 font_weight_600 black--text text-right px-0" style="border-top: 1px solid #eee; background: #f4faff; width: 198px; max-width: 198px; min-width: 198px">
                                {{ total_aktiva.total_debit | price }}
                              </td>
                              <td class="fs-12 py-1 font_weight_600 black--text text-right px-0" style="border-top: 1px solid #eee; background: #f4faff; width: 198px; max-width: 198px; min-width: 198px">
                                {{ total_aktiva.total_kredit | price }}
                              </td>
                              <td class="fs-12 py-1 font_weight_600 black--text text-right px-0" style="border-top: 1px solid #eee; background: #f4faff; width: 198px; max-width: 198px; min-width: 198px">
                                {{ total_aktiva.saldo_akhir | price }}
                              </td>
                            </tr>
                          </table>
    
                            <div class="fs-14 pb-2 pt-2 black_one font_weight_600 px-5 pr-2" style="border-top: 1px solid #eee; position: sticky; top: 0; background: #fff; z-index: 1;">
                              <div class="d-flex align-center">
                                <div>
                                  Pasiva
                                </div>
                                <!-- <div class="ml-auto">
                                  {{ total_pasiva | price }}
                                </div> -->
                              </div>
                            </div>
                            
                            <v-treeview
                              :items="list_pasiva"
                              item-key="id"
                              activatable
                              open-all

                              item-children="child"
                              item-text="test"
                              class="border_buttom_tree fs-12"
                            >
                              <template v-slot:prepend="{ item }">
                                <!-- <v-icon v-if="item.child">
                                  {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                                </v-icon>
                                <v-icon v-else>{{ 'mdi-file-document-outline' }}</v-icon> -->
                                <div class="d-flex">
                                  <div :class="item.child.length > 0 || item.is_parent === true  ? 'font_weight_600' : ''">
                                    {{ item.number }}
                                  </div>
                                </div>
        
                                <!-- <v-tooltip 
                                  top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      v-bind="attrs"
                                      v-on="on"
                                      min-width="24"
                                      min-height="24"
                                      x-small
                                      rounded
                                      @click="dialog.status = true; reset(item);"
                                      color="orange"
                                      elevation="0"
                                      class="white--text text-capitalize mx-1 px-0"
                                      style="font-weight: 600; border-radius: 6px;">
                                      <v-icon size="12">mdi-file-cancel</v-icon>
                                      
                                    </v-btn>
                                  </template>
          
                                  <span>Nonaktifkan</span>
                                </v-tooltip> -->
        

                              </template>
                              <!-- <template v-slot:label="{item}">
                                <div class="v-treeview-node__label">{{item.data.name_label}}</div>
                              </template> -->
                              <template v-slot:append="{ item }">
                                <div class="d-flex">
                                  <div style="min-width: 400px; max-width: 400px; padding-left: 30px;" :class="item.child.length > 0 || item.is_parent === true  ? 'font_weight_600 fs-11' : 'fs-11'">
                                    {{ item.name }}
                                  </div>
                                  <div class="ml-auto text-right" style="min-width: 196px; padding-left: 70px;" calss="text-capitalize" :class="item.child.length > 0 || item.is_parent === true  ? 'font_weight_600 fs-11' : 'fs-11'">
                                    {{ item.saldo_awal | price }}
                                  </div>
                                  <div class="ml-auto text-right" style="min-width: 196px; padding-left: 70px;" calss="text-capitalize" :class="item.child.length > 0 || item.is_parent === true  ? 'font_weight_600 fs-11' : 'fs-11'">
                                    {{ item.total_debit | price }}
                                  </div>
                                  <div class="ml-auto text-right" style="min-width: 196px; padding-left: 70px;" calss="text-capitalize" :class="item.child.length > 0 || item.is_parent === true  ? 'font_weight_600 fs-11' : 'fs-11'">
                                    {{ item.total_kredit | price }}
                                  </div>
                                  <div class="ml-auto text-right" style="min-width: 196px; padding-left: 70px;" calss="text-capitalize" :class="item.child.length > 0 || item.is_parent === true  ? 'font_weight_600 fs-11' : 'fs-11'">
                                    {{ item.saldo_akhir | price }}
                                  </div>
                                </div>
                              </template>
                            </v-treeview>
                            <table style="width: fit-content;">
                            <tr>
                              <td class="fs-12 font_weight_600 black--text py-1 px-5" style="border-top: 1px solid #eee; background: #f4faff; min-width: 200px; width: 200px">
                                TOTAL PASIVA
                              </td>
                              <td class="fs-12 py-1 font_weight_600 black--text" style="border-top: 1px solid #eee; background: #f4faff; width: 400px; max-width: 400px; min-width: 400px; padding-left: 30px; text-align: left;">
                                
                              </td>
                              <td class="fs-12 py-1 font_weight_600 black--text text-right px-0" style="border-top: 1px solid #eee; background: #f4faff; width: 198px; max-width: 198px; min-width: 198px">
                                {{ total_pasiva.saldo_awal | price }}
                              </td>
                              <td class="fs-12 py-1 font_weight_600 black--text text-right px-0" style="border-top: 1px solid #eee; background: #f4faff; width: 198px; max-width: 198px; min-width: 198px">
                                {{ total_pasiva.total_debit | price }}
                              </td>
                              <td class="fs-12 py-1 font_weight_600 black--text text-right px-0" style="border-top: 1px solid #eee; background: #f4faff; width: 198px; max-width: 198px; min-width: 198px">
                                {{ total_pasiva.total_kredit | price }}
                              </td>
                              <td class="fs-12 py-1 font_weight_600 black--text text-right px-0" style="border-top: 1px solid #eee; background: #f4faff; width: 198px; max-width: 198px; min-width: 198px">
                                {{ total_pasiva.saldo_akhir | price }}
                              </td>
                            </tr>
                          </table>
                          </div>
                        </v-card-text>
                        <v-card-text
                          v-if="list_aktiva.length === 0 && list_pasiva.length === 0"
                          class="pb-0 my-4" style="height: calc( 100vh - 250px ); display: flex; align-items: center; justify-content: center;">
                          <div class="text-center">
                            <v-img 
                              class="mx-auto"
                              contain
                              alt="vuetify"
                              :width="90"
                              :height="90"
                              :src="require('@/assets/image/empty.png')">
                              <!-- <template v-slot:placeholder>
                                <v-row
                                  class=" "
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    indeterminate 
                                    :color="set_color">
                                  </v-progress-circular>
                                </v-row>
                              </template> -->
                            </v-img>
                            <div class="mt-3 fs-16">
                              Belum Ada Neraca
                            </div>
                          </div>
                        </v-card-text>
                        <v-card-actions
                          class="pa-4 py-2">
                          <div v-if="message.error.length > 0"
                            class="text-left">
                            <div
                              class="error--text d-flex align-start">
                              <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                              
                              <span
                                class="ml-1">
                                {{ message.error }}
                              </span>
                            </div>
                          </div>
                          <div v-if="note !== ''" class="fs-15 orange--text text--darken-4">
                            Catatan: {{ note }}
                          </div>
                      <v-spacer/>

                      <v-btn
                        width="120"
                        color="#4B4B4B"
                        elevation="0"
                        @click="message.komfirmasi = 'buka'; dialog.komfirmasi = true;"
                        v-if="delete_bool && hak_akses.action.tutup_buku"
                        class="fs-12 white--text text-capitalize ml-3"
                        :style="process.form || saldo_awal_bool ? '' : 'background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));'"
                        style="border-radius: 6px; font-weight: 600; ">
                        <v-icon
                          size="18">
                          mdi-checkbox-marked-circle-outline
                        </v-icon>

                        <span
                          class="ml-2">
                          Buka Buku
                        </span>
                      </v-btn>

                      <v-btn
                        width="120"
                        
                        color="orange"
                        elevation="0"
                        @click="message.komfirmasi = 'tutup'; dialog.komfirmasi = true;"
                        v-if="closing_bool && hak_akses.action.buka_buku"
                        class="fs-12 white--text text-capitalize d-flex align-center ml-4"
                        style="border-radius: 6px; font-weight: 600;">
                        <v-icon 
                          size="18">
                          mdi-progress-close
                        </v-icon>

                        <span
                          class="ml-2">
                          Tutup Buku
                        </span>
                      </v-btn>
                    </v-card-actions>
                    
                      </div>
                  </v-card>
                </v-col>
              </v-row>
            </div>
            <!-- </v-col>
          </v-row> -->

        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        tabs: [
          'internal', 'public'
        ],
        tab: 0,
        tree: [],
        checkbox: false,
        selected_data: '',
        closing_month: '',
        delete_month: '',
        delete_bool: false,
        closing_bool: false,
        dialog: {
          fullscreen: false,
          snackbar: false,
          freeze: false,
          hide: false,

          delete: false,
          reset: false,
          role: false,

          filter: false,
          form: false,
          komfirmasi: false,
        },
        
        search: '',
        picker: {
          range: false,

          start_date: false,
          end_date: false,
          month: false
        },

        menu2: false,
        filter: {
          date: '',
          year: new Date().getFullYear(),

          month: moment().format('YYYY-MM'),
          month_text: 'Januari',
        },

        selected: {
          row: [],
          freeze: [],
          delete: [],
          reset: [],
          role: [],
          activa: '',
          pasiva: ''
        },
        note: '',

        role: [],

        options: {},
        headers: [],
        list: [],
        list_aktiva: [],
        list_pasiva: [],
        pagination: {},
        total_aktiva: {},
        total_pasiva: {},

        lastIndex: 0,
        limit: 20,

        form: {
          month: moment().format('YYYY-MM'),
          position: '',
          pasiva_array: [],
          aktiva_array: []
        },

        process: {
          load: true,

          delete: false,
          reset: false,
          role: false,
          form: false
        },
        message: {
          success: '',
          error: '',
          komfirmasi: ''
        }
      }
    },
    components: {
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination.vue')
    },
    watch: {
      'filter.year': function () {
        this.fetch()
      },

      'filter.month': function () {
        let t = this

        let m = this.months.filter(function(v) {
          return t.filter.month == v.value
        })

        if (m.length > 0) {
          this.filter.month_text = m[0].text
        }
        this.fetch()
      },
      'options': {
        handler () {
          let pagination = { row: this.limit, page: 1 }
          
          this.fetch(pagination)
        },
        deep: true
      }
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      hak_akses () {
        let menu = {}
        // console.log(this.$store.state.menu)
        this.$store.state.menu.map(item => {
          if (item.id === 6) {
            menu = item
          }
        })
        return menu
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },
      years () {
        let max = new Date().getFullYear()+4, min = max - 8, years = []

        for (let i = max; i >= min; i--) {
          years.push({
            text: i,
            value: i
          })
        }

        return years
      },
      months () {
        let numb = new Date().getMonth() + 1
        

        return [
          {
            text: 'Januari',
            value: 1
          },
          {
            text: 'Februari',
            value: 2
          },
          {
            text: 'Maret',
            value: 3
          },
          {
            text: 'April',
            value: 4
          },
          {
            text: 'Mei',
            value: 5
          },
          {
            text: 'Juni',
            value: 6
          },
          {
            text: 'Juli',
            value: 7
          },
          {
            text: 'Agustus',
            value: 8
          },
          {
            text: 'September',
            value: 9
          },
          {
            text: 'Oktober',
            value: 10
          },
          {
            text: 'November',
            value: 11
          },
          {
            text: 'Desember',
            value: 12
          }
        ]
      },

      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      rowFormat (format, value) {
        let data = value

        if (format === 'number') {
          if (isNaN(value)) return 'Not a Number'
          let price = ''

          const reverseNumber = value
            .toString()
            .split('')
            .reverse()
            .join('')
          const arrReverseNumber = [...Array(reverseNumber.length).keys()]

          arrReverseNumber.map(index => {
            if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
          })

          return `Rp ${
            price.split('', price.length - 1)
            .reverse()
            .join('')
          }`
        } else if (format === 'array') {
          let arr = []

          for (let i = 0; i < value.length; i++) {
            arr.push(value[i].label)
          }

          data = arr.join(', ')
        } else if (format === 'date') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
        } else if (format === 'time') {
          data = value.length > 0 ? moment(value).format('HH:mm') : '-'
        } else if (format === 'datetime') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY HH:mm') : '-'
        } else if (format === 'object') {
          data = value.createdby.name
        } else if (format === 'regex') {
          let regex = /(<([^>]+)>)/ig

          data = value.replace(regex, '')
        } else if (format === 'underscore') {
          let regex = /_/g

          data = value.replace(regex, ' ')
        } else if (format === 'on_off') {
          data = value ? 'Online' : 'Offline'
        } else if (format === 'g_m') {
          data = value ? 'Mandiri' : 'Group'
        } else if (format === 'v_a') {
          data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
        } else if (format === 'y_n') {
          data = parseInt(value) ? 'Ya' : 'Tidak'
        } else if (format === 'percent') {
          data = Number(value) + ' %'
        } else if (format === 'action') {
          data = value
        } else if (format === 'bool') {
          data = value
        } else if (format === 'status') {
          data = value
        } else if (format === 'link') {
          data = value
        }  else {
          data = value ? 'Aktif' : 'Tidak Aktif'
        }

        return data
      },
      rowClick (item, row) {
        row.select(!row.isSelected ? true : false)
      },
      doubleClick (event, {item}) {
        // NO ACTION
      },
      handleToggleAll (event) {
        if (!event.value) this.selected.row = []
      },

      async fetch (pagination = { row: 20, page: 1 }) {
        this.process.load = true

        this.limit = pagination.row

        let params = {
          // limit: pagination.row,
          // page: pagination.page,
          // sort: this.options.sortBy.length < 1 ? '-id' : this.options.sortBy[0],
          // order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
          // search: this.search
          // month: this.filter.month
          position: this.tabs[this.tab]
        }

        this.selected.row = []

        await get(`neraca/closing/data`, { params })
        .then(response => {
          let res = response.data

          this.list_aktiva = []
          this.list_pasiva = []
          this.pagination = {}
            
          if (res.status === 200) {
            this.headers = [
              // {
              //   text: 'Aksi',
              //   width: '120px',
              //   value: 'id',
              //   freeze: true,
              //   hide: false,
              //   align: 'center',
              //   format: 'action'
              // },
              // {
              //   text: 'Nomor Induk Pegawai',
              //   width: '200px',
              //   value: 'nip',
              //   freeze: false,
              //   hide: false
              // },
              {
                text: 'Nama',
                width: '100%',
                value: 'name',
                freeze: false,
                hide: false
              }
            ]
            res.results.data.aktiva_array.map((item, index) => {
              this.list_aktiva.push(item)
            })
            res.results.data.pasiva_array.map((item, index) => {
              this.list_pasiva.push(item)
            })
            this.closing_month = res.results.data.closing_month
            this.delete_month = res.results.data.delete_month
            this.total_aktiva = res.results.data.total_aktiva
            this.total_pasiva = res.results.data.total_pasiva
            this.delete_bool = res.results.data.delete_bool
            this.closing_bool = res.results.data.closing_bool
            this.note = res.results.data.note
            // this.list.map((item, index) => {
            //   this.total_aktiva += (item.balance*1)
            // })

            // this.list_pasiva.map((item, index) => {
            //   this.total_pasiva += (item.balance*1)
            // })

            // this.list = res.results.data
            // this.pagination = res.results.pagination


            // this.lastIndex = (pagination.page - 1) * pagination.row 
            // this.lastIndex += 1

            // this.addFreezes()

            // this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper-neraca') })

            // if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()

          this.process.load = false
          }
        })
      },


      // closeForm() {
      //   this.form.pasiva_array = []
      //   this.form.aktiva_array = []
      //   this.list_aktiva.map((item, index) => {
      //     this.form.aktiva_array.push(item)
      //   })

      //   this.list_pasiva.map((item, index) => {
      //     this.form.pasiva_array.push(item)
      //   })
      // },

      reset () {
        if (this.$refs.form) this.$refs.form.reset()

        this.form.month = moment().format('YYYY-MM')
        this.form.position = ''
        this.message.error = ''
        this.form.pasiva_array = []
        this.form.aktiva_array = []
        this.list_aktiva.map((item, index) => {
          this.form.aktiva_array.push(item)
        })

        this.list_pasiva.map((item, index) => {
          this.form.pasiva_array.push(item)
        })
      },

      addFreezes () {
        this.removeFreezes()

        this.selected.freeze = []

        for (let i = 0; i < this.configHeaders.length; i++) {
          if (this.configHeaders[i].freeze) {
            // ADD TO SELECTOR
            this.selected.freeze.push({
              child: i + (this.checkbox ? 2 : 1),
              width: this.configHeaders[i].width.split('px')[0]
            })

            // LOOP STYLESHEET
            for (let f = 0; f < this.selected.freeze.length; f++) {
              let style = document.createElement('style'),
                  width = 0

              if (this.checkbox) {
                width = f < 1 ? '65' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
              } else {
                width = f < 1 ? '0' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
              }

              // ADD STYLESHET TO FREEZE
              style.innerHTML = `
                .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 5;
                  background: #FFFFFF;
                }

                .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 1;
                }
              `

              // ADD TO APPENDCHILD
              document.head.appendChild(style)
            }
          }
        }
      },
      removeFreezes () {
        // LOOP STYLESHEET
        for (let f = 0; f < this.selected.freeze.length; f++) {
          let style = document.createElement('style')
          
          // RESET STYLESHEET TO AUTO
          style.innerHTML = `
            .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
              background: #FFFFFF;
            }

            .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
            }
          `

          // ADD TO APPENDCHILD
          document.head.appendChild(style)
        }
      },
      addHides () {
        if (this.headers.length < 6) this.getTableToResize()
      },
      getTableToResize () {
        let tables = document.getElementsByTagName('table')

        for (let i = 0; i < tables.length; i++) {
          this.resizableGrid(tables[i])
        }
      },
      resizableGrid (table) {
        let row = table.getElementsByTagName('tr')[0],
            cols = row ? row.children : undefined
        
        if (!cols) return
        
        table.style.overflow = 'hidden'
        
        let tableHeight = table.offsetHeight
        
        for (let i = 0; i < cols.length; i++) {
          let div = createDiv(tableHeight)
          cols[i].appendChild(div)
          cols[i].style.position = 'relative'

          setListeners(div)
        }

        function setListeners (div) {
          let pageX, curCol, nxtCol, curColWidth, nxtColWidth

          div.addEventListener('mousedown', e => {
            curCol = e.target.parentElement
            nxtCol = curCol.nextElementSibling
            pageX = e.pageX
            
            let padding = paddingDiff(curCol)
            
            curColWidth = curCol.offsetWidth - padding

            if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
          })

          div.addEventListener ('mouseover', e => {
            e.target.style.borderRight = '2px solid #e0e0e0'
          })

          div.addEventListener ('mouseout', e => {
            e.target.style.borderRight = ''
          })

          document.addEventListener ('mousemove', e => {
            if (curCol) {
              let diffX = e.pageX - pageX
          
              if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'

              curCol.style.width = (curColWidth + diffX)+'px'
            }
          })

          document.addEventListener ('mouseup', () => { 
            curCol = undefined
            nxtCol = undefined
            pageX = undefined
            nxtColWidth = undefined
            curColWidth = undefined
          })
        }

        function createDiv (height) {
          let div = document.createElement('div')

          div.style.top = 0
          div.style.right = 0
          div.style.width = '1px'
          div.style.position = 'absolute'
          div.style.cursor = 'col-resize'
          div.style.userSelect = 'none'
          div.style.height = height + 'px'
          div.style.background = '#e0e0e0'

          return div
        }

        function paddingDiff (col) {
          if (getStyleVal(col,'box-sizing') == 'border-box') {
            return 0
          }
          
          let padLeft = getStyleVal(col,'padding-left')
          let padRight = getStyleVal(col,'padding-right')

          return (parseInt(padLeft) + parseInt(padRight))
        }

        function getStyleVal (elm,css) {
          return (window.getComputedStyle(elm, null).getPropertyValue(css))
        }
      },

      async save () {
        this.message.error = ''

        const isValid = true

        if (isValid) {
          this.process.form = true

          let url = this.message.komfirmasi === 'buka' ? 'neraca/closing/delete' : 'neraca/closing/add'

          // SAVE TO REST API
          await post(url, {
            data: {
              position: this.tabs[this.tab]
            }
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.komfirmasi = false
              this.message.komfirmasi = ''

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              // if (this.form.id === '') {
              //   this.fetch()
              // } else {
              //   this.fetch(this.paginationList)
              // }
              // this.fetchData()
              this.fetch()
              // this.reset()

            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          // setTimeout(() => {
          //   const errors = Object.entries(this.$refs.form.errors)
          //     .map(([key, value]) => ({ key, value }))
          //     .filter(error => error['value'].length)
          //   this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
          //     behavior: 'smooth',
          //     block: 'center'
          //   })
          // }, 10)
        }
      },

      toDelete (id) {
        this.selected.delete = [id]

        this.dialog.delete = true
      },
      async deletes () {
        this.message.error = ''

        this.process.delete = true

        await post(`pos/satuan/delete`, {
          data: {
            id: this.selected.delete[0]
          }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.status === 200) {

            this.dialog.delete = false

            this.selected.row = []
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch(this.paginationList)
          } else {
            this.message.error = res.message
          }
        })
      }

    }
  }
</script>


<style>
table, th, td {
  /* border: 1px solid #ededed;
  border-collapse: collapse; */
  /* border: thin ridge black; */
  border-spacing: 4px;
  border-collapse: collapse;
}

.view {
  margin: auto;
  width: 100%;
}

.wrapper-neraca { 
  overflow-y: auto; 
  height: calc(100vh - 260px); 
} 
.wrapper-neraca th { 
  position: sticky; 
  top: 0; 
  background-color: white !important;
} 
.list_hover:hover {background-color: #1976d236;}
.selected {background-color: #1976d236;}

</style>